import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  SCHEDULE_UPDATE_SCHEDULE_BEGIN,
  SCHEDULE_UPDATE_SCHEDULE_SUCCESS,
  SCHEDULE_UPDATE_SCHEDULE_FAILURE,
  SCHEDULE_UPDATE_SCHEDULE_DISMISS_ERROR,
} from './constants';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function updateSchedule(args = {}) {
  return (dispatch) => {
    dispatch({
      type: SCHEDULE_UPDATE_SCHEDULE_BEGIN,
    });
    const { values, projectId, taskId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/schedules/${taskId}`;
      const doRequest = axios.post(url, values, header);
      doRequest.then(
        (res) => {
          if ((res.status === 200 || res.status === 201) && res.data) {
            dispatch({
              type: SCHEDULE_UPDATE_SCHEDULE_SUCCESS,
              data: res.data,
            });
            toast.success('Task Updated Successfully !');
            resolve(res.data);
          } else {
            const errMsg = getErrorMessageFromResponse(res);
            dispatch({
              type: SCHEDULE_UPDATE_SCHEDULE_FAILURE,
              data: { error: 'Failed' },
            });
            toast.error(`Failed: ${errMsg}`, {});
            resolve('Failed');
          }
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          if (err.response.status && err.response.status === 400) {
            dispatch({
              type: SCHEDULE_UPDATE_SCHEDULE_FAILURE,
              data: { error: errMsg },
            });
            resolve(errMsg);
          } else {
            dispatch({
              type: SCHEDULE_UPDATE_SCHEDULE_FAILURE,
              data: { error: err },
            });
            reject(err);
          }
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateScheduleError() {
  return {
    type: SCHEDULE_UPDATE_SCHEDULE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SCHEDULE_UPDATE_SCHEDULE_BEGIN:
      return {
        ...state,
        updateSchedulePending: true,
        updateScheduleError: null,
      };

    case SCHEDULE_UPDATE_SCHEDULE_SUCCESS:
      return {
        ...state,
        updateSchedulePending: false,
        updateScheduleError: null,
      };

    case SCHEDULE_UPDATE_SCHEDULE_FAILURE:
      return {
        ...state,
        updateSchedulePending: false,
        updateScheduleError: action.data.error,
      };

    case SCHEDULE_UPDATE_SCHEDULE_DISMISS_ERROR:
      return {
        ...state,
        updateScheduleError: null,
      };

    default:
      return state;
  }
}
